// extracted by mini-css-extract-plugin
module.exports = {"mobile":"UserNav_mobile__3jJQk","menu":"UserNav_menu__36JeQ","fadeIn":"UserNav_fadeIn__nRa6H"};